import { SecureAxios } from './Axios';
import { API_ROOT } from './Constants';
const CacheKey = 'flightPlans';
const BASE_PATH = `${API_ROOT}/flightPlans`;
const PATHS = {
    ABORT: (flightPlanId) => `${BASE_PATH}/${flightPlanId}/abort`,
    CREATE: BASE_PATH,
    DELETE: (flightPlanId) => `${BASE_PATH}/${flightPlanId}`,
    EXECUTE: (flightPlanId) => `${BASE_PATH}/${flightPlanId}/execute`,
    GET: (flightPlanId) => `${BASE_PATH}/${flightPlanId}`,
    LIST: BASE_PATH,
    PAUSE: (flightPlanId) => `${BASE_PATH}/${flightPlanId}/pause`,
    RESUME: (flightPlanId) => `${BASE_PATH}/${flightPlanId}/resume`,
    UPDATE: (flightPlanId) => `${BASE_PATH}/${flightPlanId}`,
};
async function abort(csrfToken, flightPlanId) {
    return (await (await SecureAxios()).post(PATHS.ABORT(flightPlanId), {}, { headers: { 'X-CSRF-Token': csrfToken } })).data;
}
async function create(csrfToken, props) {
    return (await (await SecureAxios()).post(PATHS.CREATE, { ...props }, { headers: { 'X-CSRF-Token': csrfToken } })).data;
}
async function delete_(csrfToken, flightPlanId) {
    return (await (await SecureAxios()).delete(PATHS.DELETE(flightPlanId), { headers: { 'X-CSRF-Token': csrfToken } })).data;
}
async function execute(csrfToken, flightPlanId, props) {
    return (await (await SecureAxios()).post(PATHS.EXECUTE(flightPlanId), props, { headers: { 'X-CSRF-Token': csrfToken } }))
        .data;
}
async function get(flightPlanId, props) {
    const params = new URLSearchParams();
    if (props?.preload)
        params.append('preload', props.preload.join(','));
    return (await (await SecureAxios()).get(`${PATHS.GET(flightPlanId)}?${params.toString()}`)).data;
}
function getKey(flightPlanId, props) {
    return [CacheKey, 'get', flightPlanId, props];
}
async function list(props) {
    const params = new URLSearchParams();
    if (props.limit)
        params.append('limit', props.limit.toString());
    if (props.offset)
        params.append('offset', props.offset.toString());
    if (props.orderBy)
        params.append('orderBy', props.orderBy);
    if (props.order)
        params.append('order', props.order);
    if (props.query)
        params.append('q', props.query);
    if (props.missionId)
        params.append('missionId', props.missionId.toString());
    if (props.operatorId)
        params.append('operatorId', props.operatorId.toString());
    if (props.startAt)
        params.append('startAt', props.startAt.getTime().toString());
    if (props.preload)
        params.append('preload', props.preload.join(','));
    return (await (await SecureAxios()).get(`${PATHS.LIST}?${params.toString()}`)).data;
}
function listKey(props) {
    return [CacheKey, 'list', props];
}
async function pause(csrfToken, flightPlanId) {
    return (await (await SecureAxios()).post(PATHS.PAUSE(flightPlanId), {}, { headers: { 'X-CSRF-Token': csrfToken } })).data;
}
async function resume(csrfToken, flightPlanId) {
    return (await (await SecureAxios()).post(PATHS.RESUME(flightPlanId), {}, { headers: { 'X-CSRF-Token': csrfToken } }))
        .data;
}
async function update(csrfToken, flightPlanId, props) {
    return (await (await SecureAxios()).put(PATHS.UPDATE(flightPlanId), { ...props }, { headers: { 'X-CSRF-Token': csrfToken } })).data;
}
export default { CacheKey, abort, create, delete_, execute, get, getKey, list, listKey, pause, resume, update };
